<a class="dropdown-item" href="#" appStopClick (click)="submit(returnUri, true)">
  <i class="bwi bwi-fw bwi-link" aria-hidden="true"></i>
  {{ "linkSso" | i18n }}
</a>
